import { useQueries } from '@tanstack/react-query'

import { ProductViewModel } from '@/types/api'
import { ShortVideoProductViewModel } from '@/types/cml-api'

import { getPDPData } from '@/app/(pdp)/_utils/get-pdp-data'
import { QueryKeys } from '@/app/_utils/react-query'

export const useGetProducts = (products: ShortVideoProductViewModel[], enabled: boolean, useMockProducts = false) => {
    const slugs = products.map((product) => product.slug)
    const uniqueSlugs = Array.from(new Set(slugs))

    const queries = useQueries<Array<{ queryFnData: ProductViewModel }>>({
        queries: uniqueSlugs.map((slug) => ({
            queryKey: QueryKeys.PDP.ProductData(slug ?? ''),
            queryFn: () => getPDPData(slug || ''),
            enabled,
        })),
    })

    if (useMockProducts) {
        return Array.from({ length: 2 }, (_, index) => ({
            id: index.toString(),
            productDescription: '',
            brandName: '',
            originalPrice: '',
            discountedPrice: '',
            discountPercentage: '',
            productImages: [''],
            slug: '',
            isLoading: true,
        }))
    }

    const data = queries
        .map((query, index) => {
            if (query.error) return null

            const product = query.data

            const productTitle = product?.pageH1 || `${product?.nameFa} ${product?.brand?.nameFa}` || ''

            return {
                id: product?.id || index.toString(),
                productDescription: productTitle,
                brandName: product?.brand?.nameFa || '',
                effectivePrice: product?.salesPrice?.toString() || '',
                basePrice: product?.basePrice?.toString() || '',
                originalPrice: product?.basePrice?.toString() || '',
                discountedPrice: product?.discountPrice?.toString() || '',
                discountPercentage: product?.discountPercent?.toString() || '',
                productImages: [product?.mainImageUrl || ''],
                isSalable: product?.isSalable || false,
                isLoading: query.isPending,
                slug: product?.slug || '',
            }
        })
        .filter((product) => product !== null)
        .sort((a, b) => {
            if (a.isLoading || b.isLoading) return 0
            if (a.isSalable && !b.isSalable) return -1
            if (!a.isSalable && b.isSalable) return 1
            return 0
        })

    return data
}
